export default __webpack_public_path__ + "static/media/BWGroup1862.dc9ec69e.svg";